import ExhibitionStatisticsContainer from "../../../Component/Application/ExhibitionStatistics/ExhibitionStatisticsContainer";

const ExhibitionStatisticsPage = () => {

    return (
        <div className="page-body">
            <ExhibitionStatisticsContainer />
        </div>
    );
};

export default ExhibitionStatisticsPage;